const TRADED_AND_SOURCES_OLD = {"trades": [{"id": 1, "name": "XBT/USD", "info": null, "source_id": 3, "base": {"id": 9, "name": "Bitcoin", "symbol": "XBT", "label": "CR", "currency": "XBT", "info": null, "asset_class_id": 3, "location_id": 1, "sector_id": 2}, "target": {"id": 1, "name": "USD", "symbol": "USD", "label": "FX", "currency": "USD", "info": null, "asset_class_id": 1, "location_id": 1, "sector_id": 2}, "values": {"trend": 0,"volume": "0.052917450000000005", "price": "23723.6"}}, {"id": 2, "name": "ETH/USD", "info": null, "source_id": 3, "base": {"id": 11, "name": "Ethereum", "symbol": "ETH", "label": "CR", "currency": "ETH", "info": null, "asset_class_id": 3, "location_id": 1, "sector_id": 2}, "target": {"id": 1, "name": "USD", "symbol": "USD", "label": "FX", "currency": "USD", "info": null, "asset_class_id": 1, "location_id": 1, "sector_id": 2}, "values": {"trend": 10,"volume": "1.48520055", "price": "1656.7849999999999"}}, {"id": 3, "name": "DOT/USD", "info": null, "source_id": 3, "base": {"id": 19, "name": "Polkadot", "symbol": "DOT", "label": "CR", "currency": "DOT", "info": null, "asset_class_id": 3, "location_id": 1, "sector_id": 2}, "target": {"id": 1, "name": "USD", "symbol": "USD", "label": "FX", "currency": "USD", "info": null, "asset_class_id": 1, "location_id": 1, "sector_id": 2}, "values": {"volume": "1.56351607", "price": "6.4692"}}, {"id": 4, "name": "ETHUSDT", "info": null, "source_id": 2, "base": {"id": 11, "name": "Ethereum", "symbol": "ETH", "label": "CR", "currency": "ETH", "info": null, "asset_class_id": 3, "location_id": 1, "sector_id": 2}, "target": {"id": 4, "name": "USDT", "symbol": "USDT", "label": "CR", "currency": "USDT", "info": null, "asset_class_id": 2, "location_id": 1, "sector_id": 2}, "values": {"trend": 25,"volume": "559.3459999999991", "price": "1645.475"}}, {"id": 5, "name": "USDT/USD", "info": null, "source_id": 3, "base": {"id": 4, "name": "USDT", "symbol": "USDT", "label": "CR", "currency": "USDT", "info": null, "asset_class_id": 2, "location_id": 1, "sector_id": 2}, "target": {"id": 1, "name": "USD", "symbol": "USD", "label": "FX", "currency": "USD", "info": null, "asset_class_id": 1, "location_id": 1, "sector_id": 2}, "values": {"trend": 40,"volume": "1587.4962549099998", "price": "1.0000499999999999"}}, {"id": 6, "name": "BNBUSDT", "info": null, "source_id": 2, "base": {"id": 12, "name": "BNB", "symbol": "BNB", "label": "CR", "currency": "BNB", "info": null, "asset_class_id": 3, "location_id": 1, "sector_id": 2}, "target": {"id": 4, "name": "USDT", "symbol": "USDT", "label": "CR", "currency": "USDT", "info": null, "asset_class_id": 2, "location_id": 1, "sector_id": 2}, "values": {"volume": "28.491999999999994", "price": "301.75"}}, {"id": 7, "name": "SOL/USD", "info": null, "source_id": 3, "base": {"id": 18, "name": "Solana", "symbol": "SOL", "label": "CR", "currency": "SOL", "info": null, "asset_class_id": 3, "location_id": 1, "sector_id": 2}, "target": {"id": 1, "name": "USD", "symbol": "USD", "label": "FX", "currency": "USD", "info": null, "asset_class_id": 1, "location_id": 1, "sector_id": 2}, "values": {"volume": "53.888", "price": "22.52"}}, {"id": 8, "name": "AVAX/USD", "info": null, "source_id": 3, "base": {"id": 23, "name": "Avalanche", "symbol": "AVAX", "label": "CR", "currency": "AVAX", "info": null, "asset_class_id": 3, "location_id": 1, "sector_id": 2}, "target": {"id": 1, "name": "USD", "symbol": "USD", "label": "FX", "currency": "USD", "info": null, "asset_class_id": 1, "location_id": 1, "sector_id": 2}, "values": {"volume": "61.819", "price": "17.6"}}, {"id": 9, "name": "ATOMUSDT", "info": null, "source_id": 2, "base": {"id": 27, "name": "Cosmos", "symbol": "ATOM", "label": "CR", "currency": "ATOM", "info": null, "asset_class_id": 3, "location_id": 1, "sector_id": 2}, "target": {"id": 4, "name": "USDT", "symbol": "USDT", "label": "CR", "currency": "USDT", "info": null, "asset_class_id": 2, "location_id": 1, "sector_id": 2}, "values": {"volume": "480.3700000000001", "price": "12.724"}}, {"id": 10, "name": "BUSDUSDT", "info": null, "source_id": 2, "base": {"id": 14, "name": "Binance USD", "symbol": "BUSD", "label": "CR", "currency": "BUSD", "info": null, "asset_class_id": 3, "location_id": 1, "sector_id": 2}, "target": {"id": 4, "name": "USDT", "symbol": "USDT", "label": "CR", "currency": "USDT", "info": null, "asset_class_id": 2, "location_id": 1, "sector_id": 2}, "values": {"volume": "104000.0", "price": "0.9998"}}, {"id": 11, "name": "XDG/USD", "info": null, "source_id": 3, "base": {"id": 10, "name": "Decentral Games", "symbol": "XDG", "label": "CR", "currency": "XDG", "info": null, "asset_class_id": 3, "location_id": 1, "sector_id": 2}, "target": {"id": 1, "name": "USD", "symbol": "USD", "label": "FX", "currency": "USD", "info": null, "asset_class_id": 1, "location_id": 1, "sector_id": 2}, "values": {"volume": "0.0", "price": "0.0818307"}}, {"id": 12, "name": "XRP/USD", "info": null, "source_id": 3, "base": {"id": 13, "name": "XRP", "symbol": "XRP", "label": "CR", "currency": "XRP", "info": null, "asset_class_id": 3, "location_id": 1, "sector_id": 2}, "target": {"id": 1, "name": "USD", "symbol": "USD", "label": "FX", "currency": "USD", "info": null, "asset_class_id": 1, "location_id": 1, "sector_id": 2}, "values": {"volume": "21.0316157", "price": "0.38124"}}, {"id": 13, "name": "ADA/USD", "info": null, "source_id": 3, "base": {"id": 15, "name": "Cardano", "symbol": "ADA", "label": "CR", "currency": "ADA", "info": null, "asset_class_id": 3, "location_id": 1, "sector_id": 2}, "target": {"id": 1, "name": "USD", "symbol": "USD", "label": "FX", "currency": "USD", "info": null, "asset_class_id": 1, "location_id": 1, "sector_id": 2}, "values": {"volume": "88.03999999999999", "price": "0.3611"}}, {"id": 14, "name": "MATICUSDT", "info": null, "source_id": 2, "base": {"id": 16, "name": "Polygon", "symbol": "MATIC", "label": "CR", "currency": "MATIC", "info": null, "asset_class_id": 3, "location_id": 1, "sector_id": 2}, "target": {"id": 4, "name": "USDT", "symbol": "USDT", "label": "CR", "currency": "USDT", "info": null, "asset_class_id": 2, "location_id": 1, "sector_id": 2}, "values": {"volume": "29794.0", "price": "1.2255500000000001"}}, {"id": 15, "name": "DAI/USD", "info": null, "source_id": 3, "base": {"id": 24, "name": "Dai", "symbol": "DAI", "label": "CR", "currency": "DAI", "info": null, "asset_class_id": 3, "location_id": 1, "sector_id": 2}, "target": {"id": 1, "name": "USD", "symbol": "USD", "label": "FX", "currency": "USD", "info": null, "asset_class_id": 1, "location_id": 1, "sector_id": 2}, "values": {"volume": "25.27338242", "price": "0.99974"}}, {"id": 16, "name": "BTCUSDT", "info": null, "source_id": 2, "base": {"id": 8, "name": "Bitcoin", "symbol": "BTC", "label": "CR", "currency": "BTC", "info": null, "asset_class_id": 3, "location_id": 1, "sector_id": 2}, "target": {"id": 4, "name": "USDT", "symbol": "USDT", "label": "CR", "currency": "USDT", "info": null, "asset_class_id": 2, "location_id": 1, "sector_id": 2}, "values": {"volume": "181.42095000000106", "price": "23590.190000000002"}}, {"id": 17, "name": "USDC/USD", "info": null, "source_id": 3, "base": {"id": 7, "name": "USD Coin", "symbol": "USDC", "label": "CR", "currency": "USDC", "info": null, "asset_class_id": 3, "location_id": 1, "sector_id": 2}, "target": {"id": 1, "name": "USD", "symbol": "USD", "label": "FX", "currency": "USD", "info": null, "asset_class_id": 1, "location_id": 1, "sector_id": 2}, "values": {"volume": "0.0", "price": "1.0"}}, {"id": 18, "name": "MATIC/USD", "info": null, "source_id": 3, "base": {"id": 16, "name": "Polygon", "symbol": "MATIC", "label": "CR", "currency": "MATIC", "info": null, "asset_class_id": 3, "location_id": 1, "sector_id": 2}, "target": {"id": 1, "name": "USD", "symbol": "USD", "label": "FX", "currency": "USD", "info": null, "asset_class_id": 1, "location_id": 1, "sector_id": 2}, "values": {"volume": "432.0", "price": "1.2287499999999998"}}, {"id": 19, "name": "LTC/USD", "info": null, "source_id": 3, "base": {"id": 20, "name": "Litecoin", "symbol": "LTC", "label": "CR", "currency": "LTC", "info": null, "asset_class_id": 3, "location_id": 1, "sector_id": 2}, "target": {"id": 1, "name": "USD", "symbol": "USD", "label": "FX", "currency": "USD", "info": null, "asset_class_id": 1, "location_id": 1, "sector_id": 2}, "values": {"volume": "2.7419809", "price": "97.81"}}, {"id": 20, "name": "ATOM/USD", "info": null, "source_id": 3, "base": {"id": 27, "name": "Cosmos", "symbol": "ATOM", "label": "CR", "currency": "ATOM", "info": null, "asset_class_id": 3, "location_id": 1, "sector_id": 2}, "target": {"id": 1, "name": "USD", "symbol": "USD", "label": "FX", "currency": "USD", "info": null, "asset_class_id": 1, "location_id": 1, "sector_id": 2}, "values": {"volume": "2.5300000000000002", "price": "12.796"}}, {"id": 21, "name": "SOLUSDT", "info": null, "source_id": 2, "base": {"id": 18, "name": "Solana", "symbol": "SOL", "label": "CR", "currency": "SOL", "info": null, "asset_class_id": 3, "location_id": 1, "sector_id": 2}, "target": {"id": 4, "name": "USDT", "symbol": "USDT", "label": "CR", "currency": "USDT", "info": null, "asset_class_id": 2, "location_id": 1, "sector_id": 2}, "values": {"volume": "430.16999999999996", "price": "22.43"}}, {"id": 22, "name": "LTCUSDT", "info": null, "source_id": 2, "base": {"id": 20, "name": "Litecoin", "symbol": "LTC", "label": "CR", "currency": "LTC", "info": null, "asset_class_id": 3, "location_id": 1, "sector_id": 2}, "target": {"id": 4, "name": "USDT", "symbol": "USDT", "label": "CR", "currency": "USDT", "info": null, "asset_class_id": 2, "location_id": 1, "sector_id": 2}, "values": {"volume": "750.267", "price": "97.045"}}, {"id": 23, "name": "MANAUSDT", "info": null, "source_id": 2, "base": {"id": 49, "name": "Decentraland", "symbol": "MANA", "label": "CR", "currency": "MANA", "info": null, "asset_class_id": 3, "location_id": 1, "sector_id": 2}, "target": {"id": 4, "name": "USDT", "symbol": "USDT", "label": "CR", "currency": "USDT", "info": null, "asset_class_id": 2, "location_id": 1, "sector_id": 2}, "values": {"volume": "10252.0", "price": "0.64575"}}, {"id": 24, "name": "DOGEUSDT", "info": null, "source_id": 2, "base": {"id": 17, "name": "Dogecoin", "symbol": "DOGE", "label": "CR", "currency": "DOGE", "info": null, "asset_class_id": 3, "location_id": 1, "sector_id": 2}, "target": {"id": 4, "name": "USDT", "symbol": "USDT", "label": "CR", "currency": "USDT", "info": null, "asset_class_id": 2, "location_id": 1, "sector_id": 2}, "values": {"volume": "94100.0", "price": "0.08154"}}, {"id": 25, "name": "XRPUSDT", "info": null, "source_id": 2, "base": {"id": 13, "name": "XRP", "symbol": "XRP", "label": "CR", "currency": "XRP", "info": null, "asset_class_id": 3, "location_id": 1, "sector_id": 2}, "target": {"id": 4, "name": "USDT", "symbol": "USDT", "label": "CR", "currency": "USDT", "info": null, "asset_class_id": 2, "location_id": 1, "sector_id": 2}, "values": {"volume": "641505.0", "price": "0.37870000000000004"}}, {"id": 26, "name": "ADAUSDT", "info": null, "source_id": 2, "base": {"id": 15, "name": "Cardano", "symbol": "ADA", "label": "CR", "currency": "ADA", "info": null, "asset_class_id": 3, "location_id": 1, "sector_id": 2}, "target": {"id": 4, "name": "USDT", "symbol": "USDT", "label": "CR", "currency": "USDT", "info": null, "asset_class_id": 2, "location_id": 1, "sector_id": 2}, "values": {"volume": "54161.80000000001", "price": "0.3589"}}, {"id": 27, "name": "AVAXUSDT", "info": null, "source_id": 2, "base": {"id": 23, "name": "Avalanche", "symbol": "AVAX", "label": "CR", "currency": "AVAX", "info": null, "asset_class_id": 3, "location_id": 1, "sector_id": 2}, "target": {"id": 4, "name": "USDT", "symbol": "USDT", "label": "CR", "currency": "USDT", "info": null, "asset_class_id": 2, "location_id": 1, "sector_id": 2}, "values": {"volume": "875.2099999999998", "price": "17.520000000000003"}}, {"id": 28, "name": "DOTUSDT", "info": null, "source_id": 2, "base": {"id": 19, "name": "Polkadot", "symbol": "DOT", "label": "CR", "currency": "DOT", "info": null, "asset_class_id": 3, "location_id": 1, "sector_id": 2}, "target": {"id": 4, "name": "USDT", "symbol": "USDT", "label": "CR", "currency": "USDT", "info": null, "asset_class_id": 2, "location_id": 1, "sector_id": 2}, "values": {"volume": "906.5600000000002", "price": "6.455"}}, {"id": 29, "name": "FTMUSDT", "info": null, "source_id": 2, "base": {"id": 47, "name": "Fantom", "symbol": "FTM", "label": "CR", "currency": "FTM", "info": null, "asset_class_id": 3, "location_id": 1, "sector_id": 2}, "target": {"id": 4, "name": "USDT", "symbol": "USDT", "label": "CR", "currency": "USDT", "info": null, "asset_class_id": 2, "location_id": 1, "sector_id": 2}, "values": {"volume": "46552.0", "price": "0.4565"}}, {"id": 30, "name": "NEARUSDT", "info": null, "source_id": 2, "base": {"id": 40, "name": "NEAR Protocol", "symbol": "NEAR", "label": "CR", "currency": "NEAR", "info": null, "asset_class_id": 3, "location_id": 1, "sector_id": 2}, "target": {"id": 4, "name": "USDT", "symbol": "USDT", "label": "CR", "currency": "USDT", "info": null, "asset_class_id": 2, "location_id": 1, "sector_id": 2}, "values": {"volume": "4992.199999999999", "price": "2.2984999999999998"}}, {"id": 31, "name": "XMRUSDT", "info": null, "source_id": 2, "base": {"id": 32, "name": "Monero", "symbol": "XMR", "label": "CR", "currency": "XMR", "info": null, "asset_class_id": 3, "location_id": 1, "sector_id": 2}, "target": {"id": 4, "name": "USDT", "symbol": "USDT", "label": "CR", "currency": "USDT", "info": null, "asset_class_id": 2, "location_id": 1, "sector_id": 2}, "values": {"volume": "14.578999999999999", "price": "151.25"}}, {"id": 32, "name": "LINKUSDT", "info": null, "source_id": 2, "base": {"id": 28, "name": "Chainlink", "symbol": "LINK", "label": "CR", "currency": "LINK", "info": null, "asset_class_id": 3, "location_id": 1, "sector_id": 2}, "target": {"id": 4, "name": "USDT", "symbol": "USDT", "label": "CR", "currency": "USDT", "info": null, "asset_class_id": 2, "location_id": 1, "sector_id": 2}, "values": {"volume": "1540.7400000000002", "price": "7.366"}}, {"id": 33, "name": "XTZUSDT", "info": null, "source_id": 2, "base": {"id": 58, "name": "Tezos", "symbol": "XTZ", "label": "CR", "currency": "XTZ", "info": null, "asset_class_id": 3, "location_id": 1, "sector_id": 2}, "target": {"id": 4, "name": "USDT", "symbol": "USDT", "label": "CR", "currency": "USDT", "info": null, "asset_class_id": 2, "location_id": 1, "sector_id": 2}, "values": {"volume": "2521.0", "price": "1.182"}}, {"id": 34, "name": "XMR/USD", "info": null, "source_id": 3, "base": {"id": 32, "name": "Monero", "symbol": "XMR", "label": "CR", "currency": "XMR", "info": null, "asset_class_id": 3, "location_id": 1, "sector_id": 2}, "target": {"id": 1, "name": "USD", "symbol": "USD", "label": "FX", "currency": "USD", "info": null, "asset_class_id": 1, "location_id": 1, "sector_id": 2}, "values": {"volume": "10.0", "price": "152.5"}}, {"id": 35, "name": "FTM/USD", "info": null, "source_id": 3, "base": {"id": 47, "name": "Fantom", "symbol": "FTM", "label": "CR", "currency": "FTM", "info": null, "asset_class_id": 3, "location_id": 1, "sector_id": 2}, "target": {"id": 1, "name": "USD", "symbol": "USD", "label": "FX", "currency": "USD", "info": null, "asset_class_id": 1, "location_id": 1, "sector_id": 2}, "values": {"volume": "0.0", "price": "0.4599"}}, {"id": 36, "name": "XLMUSDT", "info": null, "source_id": 2, "base": {"id": 37, "name": "Stellar", "symbol": "XLM", "label": "CR", "currency": "XLM", "info": null, "asset_class_id": 3, "location_id": 1, "sector_id": 2}, "target": {"id": 4, "name": "USDT", "symbol": "USDT", "label": "CR", "currency": "USDT", "info": null, "asset_class_id": 2, "location_id": 1, "sector_id": 2}, "values": {}}, {"id": 37, "name": "NEAR/USD", "info": null, "source_id": 3, "base": {"id": 40, "name": "NEAR Protocol", "symbol": "NEAR", "label": "CR", "currency": "NEAR", "info": null, "asset_class_id": 3, "location_id": 1, "sector_id": 2}, "target": {"id": 1, "name": "USD", "symbol": "USD", "label": "FX", "currency": "USD", "info": null, "asset_class_id": 1, "location_id": 1, "sector_id": 2}, "values": {"volume": "66.22000000000001", "price": "2.3085"}}, {"id": 38, "name": "XLM/USD", "info": null, "source_id": 3, "base": {"id": 37, "name": "Stellar", "symbol": "XLM", "label": "CR", "currency": "XLM", "info": null, "asset_class_id": 3, "location_id": 1, "sector_id": 2}, "target": {"id": 1, "name": "USD", "symbol": "USD", "label": "FX", "currency": "USD", "info": null, "asset_class_id": 1, "location_id": 1, "sector_id": 2}, "values": {}}, {"id": 39, "name": "LINK/USD", "info": null, "source_id": 3, "base": {"id": 28, "name": "Chainlink", "symbol": "LINK", "label": "CR", "currency": "LINK", "info": null, "asset_class_id": 3, "location_id": 1, "sector_id": 2}, "target": {"id": 1, "name": "USD", "symbol": "USD", "label": "FX", "currency": "USD", "info": null, "asset_class_id": 1, "location_id": 1, "sector_id": 2}, "values": {"volume": "56.17", "price": "7.4079999999999995"}}, {"id": 40, "name": "MANA/USD", "info": null, "source_id": 3, "base": {"id": 49, "name": "Decentraland", "symbol": "MANA", "label": "CR", "currency": "MANA", "info": null, "asset_class_id": 3, "location_id": 1, "sector_id": 2}, "target": {"id": 1, "name": "USD", "symbol": "USD", "label": "FX", "currency": "USD", "info": null, "asset_class_id": 1, "location_id": 1, "sector_id": 2}, "values": {"volume": "31.41", "price": "0.6509"}}], "sources": [{"id": 1, "name": "coinbase", "info": null, "type": "exchange", "url": "https://www.coinbase.com/", "timezone": "UTC", "utc_time_diff_sec": 0}, {"id": 2, "name": "binance", "info": null, "type": "exchange", "url": "https://www.binance.com/", "timezone": "UTC", "utc_time_diff_sec": 0}, {"id": 3, "name": "kraken", "info": null, "type": "exchange", "url": "https://www.kraken.com/", "timezone": "UTC", "utc_time_diff_sec": 0}, {"id": 4, "name": "alphavantage", "info": null, "type": "dataSource", "url": "https://www.alphavantage.co/", "timezone": "UTC", "utc_time_diff_sec": 0}, {"id": 5, "name": "coingecko", "info": null, "type": "dataSource", "url": "https://www.coingecko.com/", "timezone": "UTC", "utc_time_diff_sec": 0}]};

export const TRADED_AND_SOURCES= {
    "trades": [
        {
            "id": 1,
            "name": "XX*ATOM-USD",
            "info": null,
            "source_id": 1,
            "base": {
                "id": 27,
                "name": "Cosmos",
                "symbol": "ATOM",
                "label": "CR",
                "currency": "ATOM",
                "info": null,
                "asset_class_id": 3,
                "location_id": 1,
                "sector_id": 12
            },
            "target": {
                "id": 1,
                "name": "USD",
                "symbol": "USD",
                "label": "FX",
                "currency": "USD",
                "info": null,
                "asset_class_id": 1,
                "location_id": 1,
                "sector_id": 2
            },
            "values": {
                "volume": "2.5300000000000002",
                "price": "12.796"
            },
            "H24": {
                "rank": 24,
                "market_cap": 2469981334.0,
                "volume": 77328956.0,
                "price": 8.42
            },
            "WEEK": {
                "rank": 23,
                "market_cap": 2925130056.0,
                "volume": 120775116.0,
                "price": 9.99
            }
        },
        {
            "id": 2,
            "name": "DOGE-USD",
            "info": null,
            "source_id": 1,
            "base": {
                "id": 17,
                "name": "Dogecoin",
                "symbol": "DOGE",
                "label": "CR",
                "currency": "DOGE",
                "info": null,
                "asset_class_id": 3,
                "location_id": 1,
                "sector_id": 11
            },
            "target": {
                "id": 1,
                "name": "USD",
                "symbol": "USD",
                "label": "FX",
                "currency": "USD",
                "info": null,
                "asset_class_id": 1,
                "location_id": 1,
                "sector_id": 2
            },
            "values": {
                "volume": "18671.8",
                "price": "0.08179"
            },
            "H24": {
                "rank": 9,
                "market_cap": 8608521290.0,
                "volume": 308425324.0,
                "price": 0.061525
            },
            "WEEK": {
                "rank": 9,
                "market_cap": 9306786647.0,
                "volume": 664114359.0,
                "price": 0.066577
            }
        },
        {
            "id": 3,
            "name": "USDT-USD",
            "info": null,
            "source_id": 1,
            "base": {
                "id": 4,
                "name": "USDT",
                "symbol": "USDT",
                "label": "CR",
                "currency": "USDT",
                "info": null,
                "asset_class_id": 2,
                "location_id": 1,
                "sector_id": 13
            },
            "target": {
                "id": 1,
                "name": "USD",
                "symbol": "USD",
                "label": "FX",
                "currency": "USD",
                "info": null,
                "asset_class_id": 1,
                "location_id": 1,
                "sector_id": 2
            },
            "values": {
                "volume": "1587.4962549099998",
                "price": "1.0000499999999999"
            },
            "H24": {
                "rank": 3,
                "market_cap": 83372279596.0,
                "volume": 15649790094.0,
                "price": 1.0
            },
            "WEEK": {
                "rank": 3,
                "market_cap": 83223937247.0,
                "volume": 29395794025.0,
                "price": 1.001
            }
        },
        {
            "id": 4,
            "name": "MATIC-USD",
            "info": null,
            "source_id": 1,
            "base": {
                "id": 16,
                "name": "Polygon",
                "symbol": "MATIC",
                "label": "CR",
                "currency": "MATIC",
                "info": null,
                "asset_class_id": 3,
                "location_id": 1,
                "sector_id": 12
            },
            "target": {
                "id": 1,
                "name": "USD",
                "symbol": "USD",
                "label": "FX",
                "currency": "USD",
                "info": null,
                "asset_class_id": 1,
                "location_id": 1,
                "sector_id": 2
            },
            "values": {
                "volume": "432.0",
                "price": "1.2287499999999998"
            },
            "H24": {
                "rank": 12,
                "market_cap": 5879249887.0,
                "volume": 580652276.0,
                "price": 0.631693
            },
            "WEEK": {
                "rank": 11,
                "market_cap": 7727451150.0,
                "volume": 298522319.0,
                "price": 0.831397
            }
        },
        {
            "id": 5,
            "name": "BTC-USD",
            "info": null,
            "source_id": 1,
            "base": {
                "id": 8,
                "name": "Bitcoin",
                "symbol": "BTC",
                "label": "CR",
                "currency": "BTC",
                "info": null,
                "asset_class_id": 3,
                "location_id": 1,
                "sector_id": 11
            },
            "target": {
                "id": 1,
                "name": "USD",
                "symbol": "USD",
                "label": "FX",
                "currency": "USD",
                "info": null,
                "asset_class_id": 1,
                "location_id": 1,
                "sector_id": 2
            },
            "values": {
                "volume": "0.03416948",
                "price": "23722.63"
            },
            "H24": {
                "rank": 1,
                "market_cap": 502995662373.0,
                "volume": 10432388380.0,
                "price": 25934.0
            },
            "WEEK": {
                "rank": 1,
                "market_cap": 498031043912.0,
                "volume": 18480904125.0,
                "price": 25684.0
            }
        },
        {
            "id": 6,
            "name": "LINK-USD",
            "info": null,
            "source_id": 1,
            "base": {
                "id": 28,
                "name": "Chainlink",
                "symbol": "LINK",
                "label": "CR",
                "currency": "LINK",
                "info": null,
                "asset_class_id": 3,
                "location_id": 1,
                "sector_id": 7
            },
            "target": {
                "id": 1,
                "name": "USD",
                "symbol": "USD",
                "label": "FX",
                "currency": "USD",
                "info": null,
                "asset_class_id": 1,
                "location_id": 1,
                "sector_id": 2
            },
            "values": {
                "volume": "56.17",
                "price": "7.4079999999999995"
            },
            "H24": {
                "rank": 22,
                "market_cap": 2678061092.0,
                "volume": 134697058.0,
                "price": 5.16
            },
            "WEEK": {
                "rank": 22,
                "market_cap": 3129446158.0,
                "volume": 208010873.0,
                "price": 6.05
            }
        },
        {
            "id": 7,
            "name": "LTC-USD",
            "info": null,
            "source_id": 1,
            "base": {
                "id": 20,
                "name": "Litecoin",
                "symbol": "LTC",
                "label": "CR",
                "currency": "LTC",
                "info": null,
                "asset_class_id": 3,
                "location_id": 1,
                "sector_id": 11
            },
            "target": {
                "id": 1,
                "name": "USD",
                "symbol": "USD",
                "label": "FX",
                "currency": "USD",
                "info": null,
                "asset_class_id": 1,
                "location_id": 1,
                "sector_id": 2
            },
            "values": {
                "volume": "2.7419809",
                "price": "97.81"
            },
            "H24": {
                "rank": 13,
                "market_cap": 5675747104.0,
                "volume": 453247150.0,
                "price": 77.57
            },
            "WEEK": {
                "rank": 13,
                "market_cap": 6429756405.0,
                "volume": 962162386.0,
                "price": 87.82
            }
        },
        {
            "id": 8,
            "name": "ETH-USD",
            "info": null,
            "source_id": 1,
            "base": {
                "id": 11,
                "name": "Ethereum",
                "symbol": "ETH",
                "label": "CR",
                "currency": "ETH",
                "info": null,
                "asset_class_id": 3,
                "location_id": 1,
                "sector_id": 12
            },
            "target": {
                "id": 1,
                "name": "USD",
                "symbol": "USD",
                "label": "FX",
                "currency": "USD",
                "info": null,
                "asset_class_id": 1,
                "location_id": 1,
                "sector_id": 2
            },
            "values": {
                "volume": "1.48520055",
                "price": "1656.7849999999999"
            },
            "H24": {
                "rank": 2,
                "market_cap": 210602175199.0,
                "volume": 5098873874.0,
                "price": 1750.93
            },
            "WEEK": {
                "rank": 2,
                "market_cap": 217496819394.0,
                "volume": 10517614550.0,
                "price": 1809.33
            }
        },
        {
            "id": 9,
            "name": "SOL-USD",
            "info": null,
            "source_id": 1,
            "base": {
                "id": 18,
                "name": "Solana",
                "symbol": "SOL",
                "label": "CR",
                "currency": "SOL",
                "info": null,
                "asset_class_id": 3,
                "location_id": 1,
                "sector_id": 12
            },
            "target": {
                "id": 1,
                "name": "USD",
                "symbol": "USD",
                "label": "FX",
                "currency": "USD",
                "info": null,
                "asset_class_id": 1,
                "location_id": 1,
                "sector_id": 2
            },
            "values": {
                "volume": "53.888",
                "price": "22.52"
            },
            "H24": {
                "rank": 11,
                "market_cap": 6188706239.0,
                "volume": 481449548.0,
                "price": 15.49
            },
            "WEEK": {
                "rank": 10,
                "market_cap": 7917611402.0,
                "volume": 647741314.0,
                "price": 19.91
            }
        },
        {
            "id": 10,
            "name": "ADA-USD",
            "info": null,
            "source_id": 1,
            "base": {
                "id": 15,
                "name": "Cardano",
                "symbol": "ADA",
                "label": "CR",
                "currency": "ADA",
                "info": null,
                "asset_class_id": 3,
                "location_id": 1,
                "sector_id": 12
            },
            "target": {
                "id": 1,
                "name": "USD",
                "symbol": "USD",
                "label": "FX",
                "currency": "USD",
                "info": null,
                "asset_class_id": 1,
                "location_id": 1,
                "sector_id": 2
            },
            "values": {
                "volume": "88.03999999999999",
                "price": "0.3611"
            },
            "H24": {
                "rank": 8,
                "market_cap": 9534048470.0,
                "volume": 531270511.0,
                "price": 0.271366
            },
            "WEEK": {
                "rank": 8,
                "market_cap": 12263825070.0,
                "volume": 309985901.0,
                "price": 0.349689
            }
        },
        {
            "id": 11,
            "name": "AVAX-USD",
            "info": null,
            "source_id": 1,
            "base": {
                "id": 23,
                "name": "Avalanche",
                "symbol": "AVAX",
                "label": "CR",
                "currency": "AVAX",
                "info": null,
                "asset_class_id": 3,
                "location_id": 1,
                "sector_id": 12
            },
            "target": {
                "id": 1,
                "name": "USD",
                "symbol": "USD",
                "label": "FX",
                "currency": "USD",
                "info": null,
                "asset_class_id": 1,
                "location_id": 1,
                "sector_id": 2
            },
            "values": {
                "volume": "61.819",
                "price": "17.6"
            },
            "H24": {
                "rank": 18,
                "market_cap": 3985340469.0,
                "volume": 138998397.0,
                "price": 11.52
            },
            "WEEK": {
                "rank": 16,
                "market_cap": 4776453849.0,
                "volume": 247585757.0,
                "price": 13.86
            }
        },
        {
            "id": 12,
            "name": "DOT-USD",
            "info": null,
            "source_id": 1,
            "base": {
                "id": 19,
                "name": "Polkadot",
                "symbol": "DOT",
                "label": "CR",
                "currency": "DOT",
                "info": null,
                "asset_class_id": 3,
                "location_id": 1,
                "sector_id": 12
            },
            "target": {
                "id": 1,
                "name": "USD",
                "symbol": "USD",
                "label": "FX",
                "currency": "USD",
                "info": null,
                "asset_class_id": 1,
                "location_id": 1,
                "sector_id": 2
            },
            "values": {
                "volume": "1.56351607",
                "price": "6.4692"
            }
        },
        {
            "id": 13,
            "name": "NEAR-USD",
            "info": null,
            "source_id": 1,
            "base": {
                "id": 40,
                "name": "NEAR Protocol",
                "symbol": "NEAR",
                "label": "CR",
                "currency": "NEAR",
                "info": null,
                "asset_class_id": 3,
                "location_id": 1,
                "sector_id": 12
            },
            "target": {
                "id": 1,
                "name": "USD",
                "symbol": "USD",
                "label": "FX",
                "currency": "USD",
                "info": null,
                "asset_class_id": 1,
                "location_id": 1,
                "sector_id": 2
            },
            "values": {
                "volume": "66.22000000000001",
                "price": "2.3085"
            },
            "H24": {
                "rank": 40,
                "market_cap": 1105004985.0,
                "volume": 59831129.0,
                "price": 1.2
            },
            "WEEK": {
                "rank": 39,
                "market_cap": 1359149980.0,
                "volume": 99127932.0,
                "price": 1.49
            }
        },
        {
            "id": 14,
            "name": "XTZ-USD",
            "info": null,
            "source_id": 1,
            "base": {
                "id": 58,
                "name": "Tezos",
                "symbol": "XTZ",
                "label": "CR",
                "currency": "XTZ",
                "info": null,
                "asset_class_id": 3,
                "location_id": 1,
                "sector_id": 12
            },
            "target": {
                "id": 1,
                "name": "USD",
                "symbol": "USD",
                "label": "FX",
                "currency": "USD",
                "info": null,
                "asset_class_id": 1,
                "location_id": 1,
                "sector_id": 2
            },
            "values": {
                "volume": "9.55",
                "price": "1.1925"
            },
            "H24": {
                "rank": 57,
                "market_cap": 672956508.0,
                "volume": 13257717.0,
                "price": 0.718788
            },
            "WEEK": {
                "rank": 56,
                "market_cap": 803157862.0,
                "volume": 22298373.0,
                "price": 0.856988
            }
        },
        {
            "id": 15,
            "name": "MANA-USD",
            "info": null,
            "source_id": 1,
            "base": {
                "id": 49,
                "name": "Decentraland",
                "symbol": "MANA",
                "label": "CR",
                "currency": "MANA",
                "info": null,
                "asset_class_id": 3,
                "location_id": 1,
                "sector_id": 9
            },
            "target": {
                "id": 1,
                "name": "USD",
                "symbol": "USD",
                "label": "FX",
                "currency": "USD",
                "info": null,
                "asset_class_id": 1,
                "location_id": 1,
                "sector_id": 2
            },
            "values": {
                "volume": "31.41",
                "price": "0.6509"
            },
            "H24": {
                "rank": 63,
                "market_cap": 623029172.0,
                "volume": 51227546.0,
                "price": 0.339514
            },
            "WEEK": {
                "rank": 53,
                "market_cap": 834055090.0,
                "volume": 252326714.0,
                "price": 0.45616
            }
        },
        {
            "id": 16,
            "name": "DAI-USD",
            "info": null,
            "source_id": 1,
            "base": {
                "id": 24,
                "name": "Dai",
                "symbol": "DAI",
                "label": "CR",
                "currency": "DAI",
                "info": null,
                "asset_class_id": 3,
                "location_id": 1,
                "sector_id": 13
            },
            "target": {
                "id": 1,
                "name": "USD",
                "symbol": "USD",
                "label": "FX",
                "currency": "USD",
                "info": null,
                "asset_class_id": 1,
                "location_id": 1,
                "sector_id": 2
            },
            "values": {
                "volume": "25.27338242",
                "price": "0.99974"
            },
            "H24": {
                "rank": 16,
                "market_cap": 4540950075.0,
                "volume": 76531010.0,
                "price": 0.999814
            },
            "WEEK": {
                "rank": 18,
                "market_cap": 4580700723.0,
                "volume": 167759306.0,
                "price": 0.998345
            }
        },
        {
            "id": 17,
            "name": "PAX-USD",
            "info": null,
            "source_id": 1,
            "base": {
                "id": 6,
                "name": "Pax Dollar",
                "symbol": "PAX",
                "label": "CR",
                "currency": "PAX",
                "info": null,
                "asset_class_id": 2,
                "location_id": 1,
                "sector_id": 13
            },
            "target": {
                "id": 1,
                "name": "USD",
                "symbol": "USD",
                "label": "FX",
                "currency": "USD",
                "info": null,
                "asset_class_id": 1,
                "location_id": 1,
                "sector_id": 2
            },
            "values": {
                "volume": "0.0",
                "price": "0.9927"
            }
        }
    ],
    "sources": [
        {
            "id": 1,
            "name": "coinbase",
            "info": null,
            "type": "exchange",
            "url": "https://www.coinbase.com/",
            "timezone": "UTC",
            "utc_time_diff_sec": 0
        },
        {
            "id": 2,
            "name": "binance",
            "info": null,
            "type": "exchange",
            "url": "https://www.binance.com/",
            "timezone": "UTC",
            "utc_time_diff_sec": 0
        },
        {
            "id": 3,
            "name": "kraken",
            "info": null,
            "type": "exchange",
            "url": "https://www.kraken.com/",
            "timezone": "UTC",
            "utc_time_diff_sec": 0
        },
        {
            "id": 4,
            "name": "alphavantage",
            "info": null,
            "type": "dataSource",
            "url": "https://www.alphavantage.co/",
            "timezone": "UTC",
            "utc_time_diff_sec": 0
        },
        {
            "id": 5,
            "name": "coingecko",
            "info": null,
            "type": "dataSource",
            "url": "https://www.coingecko.com/",
            "timezone": "UTC",
            "utc_time_diff_sec": 0
        },
        {
            "id": 6,
            "name": "polygon",
            "info": null,
            "type": "dataSource",
            "url": "https://polygon.io/",
            "timezone": "UTC",
            "utc_time_diff_sec": 0
        },
        {
            "id": 7,
            "name": "polygon_rest",
            "info": null,
            "type": "dataSource",
            "url": "https://polygon.io/",
            "timezone": "UTC",
            "utc_time_diff_sec": 0
        },
        {
            "id": 8,
            "name": "polygon_ws",
            "info": null,
            "type": "dataSource",
            "url": "https://polygon.io/",
            "timezone": "UTC",
            "utc_time_diff_sec": 0
        }
    ]
};
